import { defineSlotRecipe } from '@chakra-ui/react';
import { tableAnatomy } from '@chakra-ui/react/anatomy';

export const tableSlotRecipe = defineSlotRecipe({
	slots: tableAnatomy.keys(),
	base: {
		root: {
			borderRadius: 'md',
			shadow: 'md',
			borderCollapse: 'separate',
			borderSpacing: '0',
			p: '3',
			bg: { base: 'white', _dark: '{colors.neutral.800}' },
		},
		row: {
			_selected: {
				bg: { base: '{colors.blue.200}', _dark: '{colors.blue.500}' },
			},
		},
		columnHeader: {
			bg: { base: 'white', _dark: '{colors.neutral.800}' },
			borderColor: { base: '{colors.neutral.100}', _dark: '{colors.neutral.300}' },
		}
	},
	variants: {
		interactive: {
			true: {
				body: {
					'& tr': {
						_hover: {
							bg: { base: '{colors.blue.200}', _dark: '{colors.blue.500}' },
							'& td': {
								bg: { base: '{colors.blue.200}', _dark: '{colors.blue.500}' },
							},
						},
					},
				},
			},
		},
		striped: {
			true: {
				row: {
					'&:nth-of-type(odd) td': {
						bg: { base: '{colors.neutral.50}', _dark: '{colors.neutral.700}' },
						borderColor: { base: '{colors.neutral.100}', _dark: '{colors.neutral.300}' },
					},
					'&:nth-of-type(even) td': {
						bg: { base: 'white', _dark: '{colors.neutral.800}' },
						borderColor: { base: '{colors.neutral.100}', _dark: '{colors.neutral.300}' },
					}
				},
			},
		},
		borderless: {
			true: {
				root: {
					border: '0px',
					shadow: 'none',
					p: 0
				},
			},
		},
		stickyColumns: {
			true: {
				root: {
					'& [data-sticky]': {
						position: 'sticky',
						zIndex: 1,
						_after: {
							content: '""',
							position: 'absolute',
							pointerEvents: 'none',
							top: '0',
							bottom: '-1px',
							width: '32px',
						},
					},

					'& [data-sticky=end]': {
						_after: {
							insetInlineEnd: '0',
							translate: '100% 0',
							shadow: 'inset 8px 0px 8px -8px rgba(0, 0, 0, 0.16)',
						},
					},

					'& [data-sticky=start]': {
						_after: {
							insetInlineStart: '0',
							translate: '-100% 0',
							shadow: 'inset -8px 0px 8px -8px rgba(0, 0, 0, 0.16)',
						},
					},

					'& thead tr': {
						shadow: '0 1px 0 0 {colors.border}',
						'&:has(th[data-sticky])': {
							zIndex: 2,
						},
					},
				}
			}
		}
	}
});